import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

import type { ShareAction } from 'src/app/shared/hooks/share';

import type { ShareChannel } from './types';

const SHARE_BUTTON_CONFIG: Readonly<Record<ShareChannel, { label: TranslationKey; successLabel?: TranslationKey }>> = {
	facebook: { label: translationKey('fe.components.psf.share.buttons.short.facebook') },
	facebookMessenger: { label: translationKey('fe.components.psf.share.buttons.short.facebook_messenger') },
	twitter: { label: translationKey('fe.components.psf.share.buttons.short.twitter') },
	whatsapp: { label: translationKey('fe.components.psf.share.buttons.short.whatsapp') },
	instagram: { label: translationKey('fe.components.psf.share.buttons.short.instagram') },
	line: { label: translationKey('fe.components.psf.share.buttons.short.line') },
	email: { label: translationKey('fe.components.psf.share.buttons.short.email') },
	sms: { label: translationKey('fe.components.psf.share.buttons.short.sms') },
	copy: {
		label: translationKey('fe.components.psf.share.buttons.copy_link'),
		successLabel: translationKey('fe.components.share_buttons.copied'),
	},
	vk: { label: translationKey('fe.components.psf.share.buttons.short.vk') },
	nextdoor: { label: translationKey('corgi.psf.share.buttons.short.nextdoor') },
	mobileNativeShare: { label: translationKey('corgi.psf.share.buttons.short.mobile_share') },
};

type Result = ReadonlyArray<{
	action: () => Promise<boolean>;
	channel: ShareChannel;
	label: TranslationKey;
	successLabel?: TranslationKey;
}>;

export function mapButtonConfigs(shareActions: ReadonlyArray<ShareAction<ShareChannel>>): Result {
	return shareActions.map(({ action, channel }) => ({
		action,
		channel,
		...SHARE_BUTTON_CONFIG[channel],
	}));
}
